module.exports = __webpack_public_path__ + "static/img/advertcharge.0b1f9042.gif";